import { STAFF_SESSION_REFRESH_CODES } from '@icebreaker/shared/errors';
import { createApiSaga } from '@icebreaker/shared/store';
import { refreshForRetry } from '../api/auth.api';

/**
 * PANELİN TEK `apiSaga` FABRİKASI (panel küçük işler 1 · B-02).
 *
 * Eskiden her özellik sagası `createApiSaga({ refreshSession })` diye kendi
 * kopyasını kuruyordu ve hiçbiri personel kodlarını vermiyordu: sarmalayıcı
 * ürün kümesiyle (`TOKEN_EXPIRED` …) karar verdiği için `STAFF_SESSION_EXPIRED`
 * yenilemeye hiç gitmedi, 15 dakika sonra her ekran hata satırında kaldı.
 * Yenileme kancası ve kod kümesi artık BURADA, bir kez durur.
 *
 * `createApiSaga` panelde yalnız bu dosyada çağrılır; başka bir dosya
 * doğrudan çağırırsa `panel-api-saga.guard.spec.ts` KIRILIR.
 */
export function createPanelApiSaga() {
  return createApiSaga({
    refreshSession: refreshForRetry,
    refreshCodes: STAFF_SESSION_REFRESH_CODES,
  });
}
